export default __webpack_public_path__ + "static/media/1871.127b6a4d.png";